"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOYALTY_ARCHIVE_STATUS = exports.LOYALTY_ALL_STATUS = exports.LOYALTY_ACTIVE_STATUS = exports.ALL_ACCOUNT_ERROR_MESSAGES = exports.EAllAccountErrors = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
var EAllAccountErrors;
(function (EAllAccountErrors) {
    EAllAccountErrors["INCORRECT_OLD_PASSWORD"] = "INCORRECT_OLD_PASSWORD";
})(EAllAccountErrors || (exports.EAllAccountErrors = EAllAccountErrors = {}));
exports.ALL_ACCOUNT_ERROR_MESSAGES = {
    [EAllAccountErrors.INCORRECT_OLD_PASSWORD]: 'Invalid password',
};
exports.LOYALTY_ACTIVE_STATUS = [betweb_openapi_axios_1.AppliedCouponStatus.Created];
exports.LOYALTY_ALL_STATUS = [
    betweb_openapi_axios_1.AppliedCouponStatus.Created,
    betweb_openapi_axios_1.AppliedCouponStatus.Used,
    betweb_openapi_axios_1.AppliedCouponStatus.Expired,
];
exports.LOYALTY_ARCHIVE_STATUS = [
    betweb_openapi_axios_1.AppliedCouponStatus.Used,
    betweb_openapi_axios_1.AppliedCouponStatus.Expired,
];
//# sourceMappingURL=constants.js.map